import React from 'react'

import { Card, List, Col, Row, Typography, Divider, Statistic, Grid, Space } from 'antd'
import { CheckCircleFilled, InfoCircleFilled } from '@ant-design/icons'

import { ProductCard, UpgradeTemplateProps } from './ProductsTemplate.types'

import FAQs from 'atoms/FAQs'
import numbro from 'numbro'
import { css } from '@emotion/css'

const UpgradeTemplate: React.FunctionComponent<UpgradeTemplateProps> = ({ title, cards, faqs }) => {

  const screens = Grid.useBreakpoint()

  const getCost = (item: ProductCard) => {
    if (typeof item.priceOverride !== 'undefined') {
      return numbro(item.priceOverride / 100).formatCurrency({
        mantissa: 2,
        optionalMantissa: false,
        trimMantissa: false
      })
    } else {
      return 0
    }
  }

  return (
    <Space 
      size={'middle'}
      direction='vertical'
      style={{
        width: '100%',
        alignItems: 'center',
        padding: screens.lg ? '0 12%' : '0 24px'
      }}>
      <Typography.Title level={screens.lg ? 3 : 5}>
        {title.title}
      </Typography.Title>
      <Typography.Text type='secondary'>
        {title.subtitle}
      </Typography.Text>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          alignContent: 'center',
          height: 'max-content',
          flexDirection: screens.lg ? 'row' : 'column',
          gap: 24,
        }}>
          {cards.map((item, i) => (
            <Card
              className={css`
                .ant-card-actions > li {
                  margin: 0;
                  padding: 0;
                }  
              `}
              key={i}
              style={{ 
                width: '100%',
                height: 'auto',
                boxShadow: '0 3px 6px rgba(140,149,159,0.15)' 
              }}
              bodyStyle={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
              actions={[
                item.action
              ]}
              >
              <Card.Meta 
                style={{
                  textAlign: 'center'
                }}
                title={<Typography.Title level={3}>{item.title}</Typography.Title>}
                description={
                  <Typography.Text type='secondary'
                  >{item.description}</Typography.Text>
                }
              />
              <List
                dataSource={item.features}
                renderItem={(text, index) => {
                  return (
                    <>
                      <List.Item style={{ justifyContent: 'flex-start' }}><CheckCircleFilled style={{ color: '#2da44e', marginRight: '8px' }} /><Typography.Text>{text}</Typography.Text></List.Item>
                      {(item.features && index === item.features?.length - 1) &&
                        <List.Item style={{ justifyContent: 'flex-start' }}><InfoCircleFilled style={{ color: '#1b90ff', marginRight: '8px' }} /><Typography.Link href={item.moreInfoLink} target='_blank'>Learn More</Typography.Link></List.Item>
                      }
                    </>
                  )
                }}
              />
            </Card>
          ))}
        </div>
      {title.footer && <Typography.Link href='https://discourse.pollination.solutions/' target='_blank' style={{ textAlign: 'center' }}>{title.footer}</Typography.Link>}
      {faqs && faqs.length > 0 && 
      <>
        <Divider />
        <Col lg={24} xl={{ span: 16, offset: 4 }} style={{ marginTop: 16 }}>
          <FAQs faqs={faqs} />
          <Row style={{ marginTop: 48 }} justify='center'>
            <Typography.Link href='https://discourse.pollination.solutions/' target='_blank' referrerPolicy='no-referrer' style={{ textAlign: 'center' }}>{'Didn\'t find your question here? Ask on our forums!'}</Typography.Link>
          </Row>
        </ Col>
      </>}
    </Space>
  )
}

export default UpgradeTemplate
